<template>
	<div class="register">
		<!-- 培训服务报名表 -->
		<el-dialog class="dialogNotice" v-if="$store.state.isService" :title="title" :visible.sync="$store.state.isService" width="60%" @close="close" v-cloak>
			<el-form label-width="150px" :model="trainingForm" :rules="rules" ref="trainingForm" label-position="right">
				<el-row :gutter="20">
					<el-col :span="22">
						<el-form-item class="fn-ml30" label="公司名称：" prop="companyName">
							<el-input v-model="trainingForm.companyName" maxlength="" prop="companyName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="22">
						<el-form-item class="fn-ml30" label="税务登记号：" prop="taxRegistrationNo">
							<el-input v-model="trainingForm.taxRegistrationNo" maxlength="" prop="taxRegistrationNo"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="22">
						<el-form-item class="fn-ml30" label="公司地址：" prop="companyAddress">
							<el-input v-model="trainingForm.companyAddress" maxlength="" prop="companyAddress"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item class="fn-ml30" label="姓名：" prop="username">
							<el-input v-model="trainingForm.username" maxlength="" prop="username"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item class="fn-ml30" label="联系电话：" prop="phoneNo">
							<el-input v-model.number="trainingForm.phoneNo" maxlength="" prop="phoneNo"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item class="fn-ml30" label="性别：" prop="sex">
							<el-select v-model="trainingForm.sex" placeholder="请选择性别">
								<el-option v-for="item in select.ct_rg_sex" :key="item.code" :label="item.value" :value="item.code + ''"> </el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item class="fn-ml30" label="年龄：" prop="age">
							<el-input v-model.number="trainingForm.age" maxlength="" prop="age"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11">
						<el-form-item class="fn-ml30" label="职务：" prop="jobTitle">
							<el-input v-model="trainingForm.jobTitle" maxlength="" prop="jobTitle"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item class="fn-ml30" label="是否房协会员：" prop="isHouseVip">
							<el-select v-model="trainingForm.isHouseVip" placeholder="是否房协会员">
								<el-option v-for="item in select.ct_yse_no" :key="item.code" :label="item.value" :value="item.code + ''"> </el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="22">
						<el-form-item class="fn-ml30" label="备注：" prop="remark">
							<el-input type="textarea" :rows="4" v-model="trainingForm.remark" maxlength="" prop="remark"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remove">返 回</el-button>
				<el-button @click="submitForm('trainingForm')">提 交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { trainingServiceSaveApi, getDicts } from '../axios/request'
export default {
	name: 'TrainingService',
	data() {
		return {
			title: '', //标题
			select: {
				ct_rg_sex: [
					{ code: '1', value: '男', fcode: '0', status: '1' },
					{ code: '2', value: '女', fcode: '0', status: '1' },
				],
				ct_yse_no: [
					{ code: '0', value: '否', fcode: null, status: '1' },
					{ code: '1', value: '是', fcode: null, status: '1' },
				],
			},
			trainingForm: {
				age: null, // 年龄
				companyAddress: null, // 公司地址
				companyName: null, // 公司名称
				jobTitle: null, // 职务
				phoneNo: null, // 电话号码
				remark: null, // 备注
				sex: null, // 性别
				taxRegistrationNo: null, // 税务登记号
				trainingId: null, // 培训主键
				username: null, // 姓名
				writeDate: null, // 上传时间
				isHouseVip: null,
			},
			rules: {
				age: [
					{ required: false, message: '请输入年龄', trigger: 'blur' },
					// { type: 'number', message: '年龄必须为数字',trigger: 'change'},
				],
				companyAddress: [{ required: false, message: '请输入公司地址', trigger: 'blur' }],
				companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
				jobTitle: [{ required: false, message: '请输入职务', trigger: 'blur' }],
				phoneNo: [
					{ required: true, message: '请输入电话号码', trigger: 'blur' },
					// { type: 'number', message: '手机号必须为数字',trigger: 'change'},
					// {pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/,message: '手机号格式不对',trigger: 'change'}
				],
				remark: [{ required: false, message: '请输入备注', trigger: 'blur' }],
				sex: [{ required: false, message: '请输入性别', trigger: 'change' }],
				taxRegistrationNo: [{ required: false, message: '请输入税务登记号', trigger: 'blur' }],
				username: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				writeDate: [{ required: false, message: '请输入上传时间', trigger: 'blur' }],
				isHouseVip: [{ required: true, message: '请输入是否房协会员', trigger: 'change' }],
			},
		}
	},
	mounted() {
		this.getDict()
	},
	methods: {
		// 关闭弹窗
		remove() {
			this.$store.commit('getService', false)
			this.close()
		},
		// 获取标题字典数据
		async getDict() {
			const query = 'global_config'
			const res = await getDicts(query)
			if (res != null && res.code == 200) {
				this.title =
					res.data?.find(o => {
						if (o.code == 'px_name') {
							return o || {}
						}
					})?.value ?? ''
			}
			// '《城市更新项目管理人员职业（岗位）能力培训》报名表'
		},
		// 初始化表单
		close() {
			this.trainingForm.age = null
			this.trainingForm.companyAddress = null
			this.trainingForm.companyName = null
			this.trainingForm.jobTitle = null
			this.trainingForm.phoneNo = null
			this.trainingForm.remark = null
			this.trainingForm.sex = null
			this.trainingForm.taxRegistrationNo = null
			this.trainingForm.username = null
			this.trainingForm.isHouseVip = null
		},
		// 提交
		submitForm(formName) {
			let _this = this
			_this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this
						.$confirm('确定并下载报名表', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						})
						.then(function () {
							if (_this.trainingForm.trainingId) {
								_this.save('update')
							} else {
								_this.save('save')
							}
						})
						.catch(function () {})
				}
			})
		},
		// 下载报名表
		async save(url) {
			let _this = this
			const res = await trainingServiceSaveApi(url, _this.trainingForm)
			if (res != null && res.code == 200) {
				if (res.success) {
					_this.$message.success(res.msg)
					_this.remove()
					window.open(process.env.VUE_APP_BASE_URL_API2 + '/nkyxf/px-training-t/downloadPDF/' + res.data)
				} else {
					this.$message.error(res.msg)
				}
			} else {
				this.$message.error(res.msg)
			}
		},
	},
}
</script>

<style scoped>
:deep(.el-dialog) {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 10px;
	overflow: hidden;
}

:deep(.el-dialog__header) {
	padding: 20px;
	width: 100%;
	text-align: center;
	font-weight: 600;
	background-color: #f2f2f2;
}

:deep(.el-dialog__body) {
	padding: 30px;
	width: 100%;
}

.fn-ml30 {
	margin-left: 30px;
}

:deep(.el-dialog__footer) {
	padding: 0px 20px 20px;
	width: 100%;
}

.dialog-footer {
	display: inline-block;
	width: 100%;
	text-align: center;
}

.dialog-footer .el-button {
	width: 30%;
	background-color: var(--bg-color);
	border-color: var(--bg-color);
	color: #fff;
	-webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-moz-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-ms-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.dialog-footer .el-button:hover {
	background-color: var(--bg-color-8);
	border: 1px solid var(--bg-color-8);
}

.dialog-footer .el-button:first-child {
	margin-right: 12%;
	background-color: #fff;
	border: 1px solid #dcdfe6;
	color: #606266;
}

.dialog-footer .el-button:first-child:hover {
	background-color: var(--bg-color-2);
	color: var(--bg-color);
}
</style>
